import { SVGProps } from "react";

export function PetraLogo(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M0 8C0 3.58172 3.58172 0 8 0H16C20.4183 0 24 3.58172 24 8V16C24 20.4183 20.4183 24 16 24H8C3.58172 24 0 20.4183 0 16V8Z"
        fill="#5A3FFF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.5339 12.8457C19.2998 13.8925 18.802 14.9095 18.0074 15.8051L14.9614 18.8512L14.8448 18.7347L11.219 15.1088L16.508 9.81977H9.66755V18.6846H4.37567V13.0315C4.37567 8.33475 8.18255 4.52783 12.8783 4.52783C17.5741 4.52783 20.417 8.90295 19.5339 12.8457Z"
        fill="white"
      />
    </svg>
  );
}
